import { StatusColor } from '@interacta-shared/util';
import { format } from 'date-fns';
import { AIConvoHistoryItem } from '../models/ai-convo-history.model';
import { AIConvoPanelView, PAGE_TITLES } from '../models/ai-convo-panel.model';

export function getAIConvoPanelPageTitle(
    view: AIConvoPanelView,
): string | undefined {
    return PAGE_TITLES[view];
}

export function getAIConvoHistoryTitle(item: AIConvoHistoryItem): string {
    return item.title || format(item.creationTimestamp, 'yyyy_MM_dd_HH:mm');
}

export function getAgentColorClass(
    color: StatusColor | null | undefined,
): string {
    switch (color) {
        case 'A':
            return 'bg-status-A';
        case 'B':
            return 'bg-status-B';
        case 'C':
            return 'bg-status-C';
        case 'D':
            return 'bg-status-D';
        case 'E':
            return 'bg-status-E';
        case 'F':
            return 'bg-status-F';
        case 'G':
            return 'bg-status-G';
        case 'H':
            return 'bg-status-H';
        case 'I':
            return 'bg-status-I';
        case 'J':
            return 'bg-status-J';
        case 'K':
            return 'bg-status-K';
        case 'L':
            return 'bg-status-L';
        case 'M':
            return 'bg-status-M';
        case 'N':
            return 'bg-status-N';
        case 'O':
            return 'bg-status-O';
        default:
            return 'bg-status-H';
    }
}
